import { LOCALES } from 'i18n/locales';

export const enhancedMeasuresIntl = {
    [LOCALES.ENGLISH]: {
        'enhancedMeasures.alert.plural': '<strong><count></count> asset owners with enhanced measures within search area.</strong> Check <link>enhanced measures</link> before starting works.',
        'enhancedMeasures.alert.singular': '<strong><count></count> asset owner with enhanced measures within search area.</strong> Check <link>enhanced measures</link> before starting works.',
        'enhancedMeasures.assetOwnersCount': '<strong><count></count></strong>',
        'enhancedMeasures.noFeature': 'No Feature available on map',
        'enhancedMeasures.error': 'unable to retrieve contact details, please contact the NUAR servicedesk',
        'enhancedMeasures.loading': 'Contact details missing or loading',
        'enhancedMeasures.layer': 'Layer',
        'enhancedMeasures.type': 'Type',
        'enhancedMeasures.permission.required': 'Don\'t dig without permission',
        'enhancedMeasures.notification.label': 'Sensitive Sites'

    },
    [LOCALES.WELSH]: {
        'enhancedMeasures.alert.plural': '[<strong><count></count> asset owners with enhanced measures within search area.</strong> Check <link>enhanced measures</link> before starting works.]',
        'enhancedMeasures.alert.singular': '[<strong><count></count> asset owner with enhanced measures within search area.</strong> Check <link>enhanced measures</link> before starting works.]',
        'enhancedMeasures.assetOwnersCount': '<strong><count></count></strong>',
        'enhancedMeasures.noFeature': 'Dim Nodwedd ar gael ar y map',
        'enhancedMeasures.error': 'yn methu ag adfer manylion cyswllt, cysylltwch â desg gymorth NUAR',
        'enhancedMeasures.loading': 'Manylion cyswllt ar goll neu\'n llwytho',
        'enhancedMeasures.layer': 'Haen',
        'enhancedMeasures.type': 'Math',
        'enhancedMeasures.permission.required': 'Peidiwch â chloddio heb ganiatâd',
        'enhancedMeasures.notification.label': 'Safleoedd Sensitif'

    }
};
